<div class="header">
  <span class="mat-subtitle-2">{{
    (this.inputs.initialValue == null
      ? 'ACTION_SIDEBAR_CREATE'
      : 'ACTION_SIDEBAR_EDIT'
    ) | i18nextCap
  }}</span>
  <div class="header-actions">
    @if (inputs.initialValue != null) {
      <fo-kebab-menu
        [hideIfNotAllowed]="deletePermissions"
        [items]="kebabItems"
      ></fo-kebab-menu>
    }
    <button
      mat-icon-button
      type="button"
      aria-label="Close"
      (click)="inputs.onCancel()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<form
  [formGroup]="actionForm"
  (submit)="onSave()"
  (keydown.enter)="onEnterKey($event)"
>
  <mat-form-field>
    <mat-label>{{ 'forms:title' | i18nextCap }}</mat-label>
    <input matInput formControlName="title" />
  </mat-form-field>

  <div class="field-with-plus">
    <mat-form-field>
      <mat-label>{{ 'forms:equipment' | i18nextCap }}</mat-label>
      <ng-template #equipmentsCustomChoiceOptionTemplate let-choice>
        <div class="fo-autocomplete-custom-option-container">
          <span class="title">{{ choice.name }}</span>
          <span class="subheading"
            >{{
              'ACTION_EQUIPMENTS_SELECTOR_SERIAL_NUMBER_LABEL' | i18nextCap
            }}: {{ choice.serialNumber }}</span
          >
          @switch (choice.ownership) {
            @case ('UNASSIGNED') {
              <span class="subheading ownership">{{
                'EQUIPMENT_NOT_ASSIGNED' | i18nextCap
              }}</span>
            }
            @case ('CLIENT_OWNED') {
              <span class="subheading ownership">{{
                'EQUIPMENT_ALREADY_ASSIGNED_TO_COMPANY' | i18nextCap
              }}</span>
            }
          }
        </div>
      </ng-template>
      <fo-autocompleting-select
        [choices]="inputs.equipmentChoices$"
        formControlName="equipment"
        [choiceOptionTemplate]="equipmentsCustomChoiceOptionTemplate"
        [matchPredicate]="equipmentsMatchPredicate"
        [activeOptionLabel]="equipmentsDisplaySelectedOptionLabel"
      >
      </fo-autocompleting-select>
      <mat-icon
        matSuffix
        class="tooltip-icon"
        [matTooltip]="inputs.equipmentsTooltipKey | i18nextCap"
        matTooltipPosition="left"
        >info_outline</mat-icon
      >
      <fo-arrow matSuffix></fo-arrow>
    </mat-form-field>
    @if (inputs.onCreateEquipment != null && inputs.canChangeEquipment) {
      <fo-plus-button (click)="onCreateEquipment()"></fo-plus-button>
    }
  </div>
  @if (inputs.showAnomalies) {
    <div class="field-with-plus">
      <mat-form-field>
        <mat-label>{{ 'forms:anomalies' | i18nextCap }}</mat-label>
        <fo-autocompleting-select-multiple
          #anomalyField
          [choices]="inputs.anomalyChoices$"
          formControlName="anomalies"
          (onNewOptionCreate)="createAnomaly($event)"
        >
        </fo-autocompleting-select-multiple>
        <fo-arrow matSuffix></fo-arrow>
      </mat-form-field>
      <fo-plus-button (click)="onCreateAnomaly()"></fo-plus-button>
    </div>
  }
  <ng-template #partsCustomChoiceOptionTemplate let-choice>
    <div class="fo-autocomplete-custom-option-container">
      <span class="title">{{ choice.name }}</span>
      <span class="subheading">Ref: {{ choice.ref }}</span>
    </div>
  </ng-template>
  <fo-parts-selector
    label="forms:parts"
    [choices]="inputs.partChoices$"
    [choiceOptionTemplate]="partsCustomChoiceOptionTemplate"
    [matchPredicate]="partsMatchPredicate"
    formControlName="parts"
  >
  </fo-parts-selector>
  <div class="request-parts-container">
    <a mat-button (click)="onRequestPart()">{{
      'forms:requestPart' | i18nextCap
    }}</a>
    <div
      class="tooltip"
      matTooltip="{{ 'forms:requestPartTooltip' | i18nextCap }}"
    >
      <mat-icon>info</mat-icon>
    </div>
  </div>
  @if (inputs.showUncataloguedParts) {
    <fo-parts-selector
      #uncataloguedParts
      label="uncataloguedParts"
      [choices]="inputs.uncataloguedPartChoices$"
      [canCreate]="true"
      (onCreate)="onCreateUncataloguedPart($event)"
      formControlName="uncataloguedParts"
    ></fo-parts-selector>
  }
  <mat-form-field>
    <mat-label>{{ 'forms:workDone' | i18nextCap }}</mat-label>
    <textarea matInput formControlName="description"> </textarea>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'forms:userObservation' | i18nextCap }}</mat-label>
    <textarea matInput formControlName="userObservation"> </textarea>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'forms:internalObservation' | i18nextCap }}</mat-label>
    <textarea matInput formControlName="internalObservation"> </textarea>
  </mat-form-field>

  <fo-file-upload
    [attachments]="attachmentSet.displayedAttachments"
    [acceptedFileTypes]="acceptedFileTypes"
    (newAttachmentsChange)="attachmentSet.update($event)"
  ></fo-file-upload>

  @if (inputs.initialValue != null) {
    <div class="creation-info">
      {{ 'createdBy' | i18nextCap }}
      {{ inputs.initialValue.createdBy.firstName }}
      {{ inputs.initialValue.createdBy.lastName }} {{ 'on' | i18next }}
      {{
        inputs.initialValue.createdAt
          | momentTimezoneToAngularTimezone: 'MMMM D, YYYY HH:mm'
      }}
    </div>
  }

  <div class="footer">
    <button mat-flat-button color="primary" type="submit">
      {{ 'save' | i18nextCap }}
    </button>
  </div>
</form>
